<template>
    <div class="section register wf-section">
    <div id="join-moijoy-container" class="container register">
      <div class="join-us-cta">
        <h1 class="no-top-margin">Fill in the basics.</h1>
        <p>To finish we&#x27;ll need a bit more information.</p>
        <div class="form-container-register">
          <div class="register-form w-form">
            <div id="wf-form-account-information" data-name="account information" class="profile-form">
              <input type="text" v-model="first_name" class="input-field profile w-input" maxlength="256" name="First-name" data-name="First name" placeholder="First name" id="First-name" required="">
              <input type="text" v-model="last_name" class="input-field profile w-input" maxlength="256" name="Last-name" data-name="Last name" placeholder="Last name" id="Last-name" required="">
              <input type="email" v-model="email" class="input-field profile w-input" maxlength="256" name="email" data-name="email" placeholder="Email address" id="email" required="">
              <button  @click="setProfileData" class="gradient-button w-button">Complete sign up</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data(){
      return {
        first_name : '',
        last_name : '',
        email: '',
      }
    },
    methods:{
      setProfileData(){
        let vm = this
        var user = firebase.auth().currentUser;
        //
        let newEmail = this.email
        let lastName = this.last_name
        let firstName = this.first_name
        //
        user.updateEmail(newEmail).then(function() {
            firebase
            .firestore()
            .collection("users")
            .doc(user.uid)
            .set({
                uid: user.uid,
                email: newEmail,
                first_name: firstName,
                last_name: lastName,
                phone_number: user.phoneNumber,
                created_time: new Date(),
          })

          vm.$router.push({path:'/thanks'})
        }).catch(function(error) {
          //Logout if session expires !
          if(error.code == 'auth/requires-recent-login'){
            alert("Your Session has been Expired to Set Password ! Please try again !")
            //
            vm.signout()
          }
        });
      },
      signout(){
        firebase.auth().signOut();
        this.$router.push({path:'/'})
        window.location.reload();  //reload on signout !
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/addProfileData.vue